export default function (homerun) {
  const winLoss = homerun.result[0].toUpperCase();

  const score = homerun.home_score > homerun.away_score
    ? `${homerun.home_team} ${homerun.home_score}, ${homerun.away_team} ${homerun.away_score}`
    : `${homerun.away_team} ${homerun.away_score}, ${homerun.home_team} ${homerun.home_score}`;

  return `${winLoss}, ${score}`;
}
